// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./confirmPatientIdentityModal.scss";
// project file imports(UI components) ⇒
import C2CCustomPopup from "../../Popups/C2CCustomPopup";
import OTPInput from "../../OTPInput";

// const file imports(helper methods, etc) ⇒

const ConfirmPatientIdentityModal = (props) => {
  // const declarations ⇒

  const {
    contentType,
    otpVerificationOption,
    handleAbhaVerificationOption,
    handleCloseVerificationPopup,
    selectedVerificationOption,
    handleVerifyOtp,
    handleOTPChange,
    handleResendOTP,
    otpError,
    verificationError,
    otpInput,
  } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  // create UI ⇒

  const renderConfirmPatientIdentityContent = () => {
    return (
      <div className="cpimc-content">
        <div className="cpimc-label">Link With:</div>
        {otpVerificationOption.map((data) => (
          <div
            className={
              "cpimc-option " + (data?.selected ? "cpimc-selected-option" : "")
            }
            onClick={() => handleAbhaVerificationOption(data)}
          >
            <div>
              <img src={data?.icon} alt="" className="cpim-label-logo" />
              {data?.label}
            </div>
          </div>
        ))}
        {verificationError && (
          <div className="cpim-error">{verificationError}</div>
        )}
      </div>
    );
  };

  const renderOTPInput = () => {
    return (
      <div className="cpim-otp-container">
        <div className="cpim-otp-label">Enter OTP</div>
        <div className="cpim-otp-info">
          We just sent you OTP on your mobile number which is linked to your
          {selectedVerificationOption === "AADHAAR_OTP"
            ? " Aadhaar Number"
            : " ABHA Address"}
          .
        </div>
        <OTPInput
          autoFocus
          hasError={otpError}
          // errorMessage={OTP_ERROR_MESSAGE}
          timerUnit={1}
          onChangeOTP={handleOTPChange}
          handleResendOTP={handleResendOTP}
        />
      </div>
    );
  };

  return (
    <div>
      {contentType === "otp" ? (
        <C2CCustomPopup
          openPopup={true}
          popupHeading="CONFIRM PATIENT IDENTITY"
          dialogClassName="confirmation-patient-identity-modal"
          handleClosePopup={handleCloseVerificationPopup}
          middleBtn="Confirm"
          middleBtnDisabled={(otpInput, otpInput?.length < 6)}
          handleMiddleBtnClick={handleVerifyOtp}
        >
          {renderOTPInput()}
        </C2CCustomPopup>
      ) : (
        <C2CCustomPopup
          openPopup={true}
          popupHeading="CONFIRM PATIENT IDENTITY"
          dialogClassName="confirmation-patient-identity-modal"
          handleClosePopup={handleCloseVerificationPopup}
        >
          {renderConfirmPatientIdentityContent()}
        </C2CCustomPopup>
      )}
    </div>
  );
};

// export ⇒

export default ConfirmPatientIdentityModal;
